/** Green animated flow used from the cooling system to production lines. */
import { type EdgeProps, getBezierPath } from '@xyflow/react';

export function AnimatedFlowGreen(props: EdgeProps) {
    const [edgePath] = getBezierPath(props);

    return (
        <g>
            <path
                d={edgePath}
                fill="none"
                stroke="#2E7D32"
                strokeWidth={3}
            />
            <path
                d={edgePath}
                fill="none"
                stroke="white"
                strokeWidth={2}
                strokeDasharray="8 12"
                style={{
                    animation: 'dash-flow 1.5s linear infinite',
                }}
            />
        </g>
    );
}
